module.exports = __webpack_public_path__ + "img/spirit_big_6.81ec333b.png";